export const appStoreLink =
  "https://apps.apple.com/us/app/the-pao-app/id1398395194"
export const instagramLink = "https://www.instagram.com/the.pao.app/"
export const youTubeLink =
  "https://www.youtube.com/channel/UCLQQy4Wzk-nPoKduW52TNoA"
export const facebookLink = "https://www.facebook.com/paoapp"
export const submissionFormLink =
  "https://docs.google.com/forms/d/e/1FAIpQLSfoNsYRCZpCfwZ2VHMXqM4eFlimEcALUv_A0VzA6EsFgEDJZQ/viewform?usp=sf_link"
